Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryUtil=require("../victory-util");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var



ClipPath=function(_React$Component){_inherits(ClipPath,_React$Component);function ClipPath(){_classCallCheck(this,ClipPath);return _possibleConstructorReturn(this,(ClipPath.__proto__||Object.getPrototypeOf(ClipPath)).apply(this,arguments));}_createClass(ClipPath,[{key:"componentWillMount",value:function componentWillMount()


















{
_extends(this,this.calculateAttributes(this.props));
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){
var calculatedAttributes=this.calculateAttributes(nextProps);
if(!_victoryUtil.Collection.allSetsEqual([
[this.props.clipId,nextProps.clipId],
[this.x,calculatedAttributes.x],
[this.y,calculatedAttributes.y],
[this.height,calculatedAttributes.height],
[this.width,calculatedAttributes.width]]))
{
_extends(this,calculatedAttributes);
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var _props$clipWidth=
props.clipWidth,clipWidth=_props$clipWidth===undefined?0:_props$clipWidth,_props$clipHeight=props.clipHeight,clipHeight=_props$clipHeight===undefined?0:_props$clipHeight,_props$translateX=props.translateX,translateX=_props$translateX===undefined?0:_props$translateX,_props$translateY=props.translateY,translateY=_props$translateY===undefined?0:_props$translateY;
var clipPadding=_victoryUtil.Helpers.getPadding({padding:props.clipPadding});

return{
x:translateX-clipPadding.left,
y:translateY-clipPadding.top,
width:Math.max(clipWidth+clipPadding.left+clipPadding.right,0),
height:Math.max(clipHeight+clipPadding.top+clipPadding.bottom,0)};

}},{key:"renderClipPath",value:function renderClipPath(


props,id){
return(
_react2.default.createElement("defs",null,
_react2.default.createElement("clipPath",{id:id},
_react2.default.createElement("rect",props))));



}},{key:"render",value:function render()

{var _props=
this.props,clipId=_props.clipId,className=_props.className;
var clipProps={className:className,x:this.x,y:this.y,width:this.width,height:this.height};
return this.renderClipPath(clipProps,clipId);
}}]);return ClipPath;}(_react2.default.Component);ClipPath.propTypes={className:_react.PropTypes.string,clipId:_react.PropTypes.number,clipHeight:_victoryUtil.PropTypes.nonNegative,clipWidth:_victoryUtil.PropTypes.nonNegative,clipPadding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number})]),translateX:_react.PropTypes.number,translateY:_react.PropTypes.number};exports.default=ClipPath;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/clip-path.js
// module id = 1376
// module chunks = 0